import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { Outlet, useNavigate } from "react-router";
import { ICustomerInformationProps } from "../../customer_profile_interface";
import CustomerInformationDefaultView from "./CustomerInformationDefaultView";
import CustomerDetailsHeaderComponent from "../CustomerDetailsHeader";
import PetInformation from "../PetInformation";
import { useLoader } from "@/app/hooks/useLoader";
import CustomerDetailsLoader from "@/app/components/ui/Loader/CustomerDetailsLoader";





const CustomerInformation: React.FC<ICustomerInformationProps> = () => {
  const { getRouteKey } = useRouter();

  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const {
    customerDetails,
    customerPets,
    customerMembershipStatus,
    customerId,
    petId,
    petDetails
  } = routeState.state as ICustomerProfileState;
  const navigate = useNavigate();

  const isCustomerDetailsFetchInProgress = useLoader("isCustomerDetailsFetchInProgress");

  const handleCustomerEdit = () => {
    let editURL = ``;
    if (customerId && petId) {
      editURL = `${getRouteKey("EDIT_CUSTOMER", "url")}/${customerId}/${petId}`;
    } else {
      editURL = `${getRouteKey("EDIT_CUSTOMER", "url")}/${customerId}${location.search}`;
    }
    navigate(editURL);
  };


  return (
    <>
      {isCustomerDetailsFetchInProgress ? (
        <CustomerDetailsLoader />
      ) : (
        <div className="rounded-xl bg-white p-2 pt-3">
          <CustomerInformationDefaultView
            handleCustomerEdit={handleCustomerEdit}
            customerDetails={customerDetails}
            customerMembershipStatus={customerMembershipStatus}
            customerPets={customerPets}
          />
          <hr className="px-2" />
          <PetInformation />
        </div>
      )}

      {petDetails && customerDetails && (
        <div className=" rounded-xl bg-white pt-0 p-2">
          <CustomerDetailsHeaderComponent />
        </div>
      )}
      <div className="pt-2">
        <Outlet />
      </div>
    </>
  );
};
export default CustomerInformation;
